import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_MFA_AUTH_ENABLED, SET_USER_AUTH, SHOW_LOADING_SPINNER } from '../actions/authActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import {
  DELETE_AUTH_CLAIMED_CHARACTER,
  DELETE_AUTH_CLAIMED_CHARACTERS,
  SET_CHARACTER_CUSTOMIZATION_PARAMS,
  SET_IS_CHINA_USER,
  UPDATE_AUTH_CLAIMED_CHARACTERS,
  updateAuthClaimedCharacters
} from '../../../../../shared/frontend/scripts/actions/userSettingsActionCreator';
import { REMOVE_REQUIRED_REGISTRATION_EVENT } from '../../../../../shared/frontend/scripts/events/store/details/modules';

export default function authReducer(state: any = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_USER_AUTH: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isLoaded: true
      };
    }
    case SET_MFA_AUTH_ENABLED: {
      return {
        ...state,
        mfaEnabled: action.payload
      };
    }
    case SET_IS_CHINA_USER: {
      return {
        ...state,
        isChinaUser: action.payload
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        ...(action.payload
          ? {
              isLoading: true,
              isLoaded: false
            }
          : {
              isLoading: false
            })
      };
    }
    case SET_CHARACTER_CUSTOMIZATION_PARAMS: {
      return updateAuthClaimedCharacters(state, action);
    }
    case UPDATE_AUTH_CLAIMED_CHARACTERS: {
      return {
        ...state,
        claimedCharacters: action.payload
      };
    }
    case DELETE_AUTH_CLAIMED_CHARACTER: {
      const claimedCharacters = state.claimedCharacters ?? [];
      return {
        ...state,
        claimedCharacters: claimedCharacters.filter((character: any) => character.id !== action.payload)
      };
    }
    case DELETE_AUTH_CLAIMED_CHARACTERS: {
      return {
        ...state,
        claimedCharacters: []
      };
    }
    case LOCATION_CHANGE: {
      return state; // keep the initial state that was loaded
    }
    case REMOVE_REQUIRED_REGISTRATION_EVENT: {
      const { eventId } = action.payload;
      const requiredRegistrationEvents = state.requiredRegistrationEvents.filter(
        (event: any) => event.event.id !== eventId
      );
      return {
        ...state,
        requiredRegistrationEvents
      };
    }

    default:
      return state;
  }
}
